(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/welcome/assets/javascripts/retail-list.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/welcome/assets/javascripts/retail-list.js');
'use strict';

const {
  useHistory
} = ReactRouterDOM;
const {
  useState,
  useRef,
  useEffect
} = React;
const {
  useDispatch
} = ReactRedux;
const {
  Button
} = svs.ui;
const {
  DocumentTitle,
  widgetArea: {
    WidgetArea
  }
} = svs.components.lbUtils;
const {
  GameList
} = svs.components.marketplace.gameList;
const {
  TeamListContainer
} = svs.components.marketplace.teamList;
const {
  WelcomeRetail
} = svs.marketplace.components.welcome;
const {
  Results
} = svs.components.marketplace.browseGames;
const {
  Filter
} = svs.components.marketplaceShared.searchFilters;
const {
  clearFilterAction,
  setFilterNameAction,
  toggleProductAction,
  setFractionCount,
  setFractionPrice,
  setSystemPrice
} = svs.components.marketplaceData.browseGames.actions;
const findPath = 'hitta-andelsspel';
const RetailList = _ref => {
  let {
    hasRetailers
  } = _ref;
  const history = useHistory();
  const dispatch = useDispatch();
  const foldRef = useRef(null);
  const listRef = useRef(null);
  const filterRef = useRef(null);
  const [foldState, setFoldState] = useState(true);
  const setFilterName = function () {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return dispatch(setFilterNameAction(value));
  };
  const toggleProduct = (product, subProductId) => dispatch(toggleProductAction(product, subProductId));
  const clearFilter = () => dispatch(clearFilterAction());
  const updateFractionPrice = (selectedMin, selectedMax) => dispatch(setFractionPrice(selectedMin, selectedMax));
  const updateFractionCount = (selectedMin, selectedMax) => dispatch(setFractionCount(selectedMin, selectedMax));
  const updateSystemPrice = (selectedMin, selectedMax) => dispatch(setSystemPrice(selectedMin, selectedMax));
  useEffect(() => {
    const wrapper = foldRef.current;
    const onExpandedComplete = target => {
      target.classList.remove('expanding');
      target.classList.add('expanded');
    };
    const onFoldedComplete = target => {
      target.classList.remove('folding');
      target.classList.add('folded');
    };
    const onTransitionEnd = _ref2 => {
      let {
        target,
        propertyName
      } = _ref2;
      if (target.contains(wrapper) && propertyName === 'max-height') {
        if (target.classList.contains('expanding')) {
          onExpandedComplete(target);
        } else if (target.classList.contains('folding')) {
          onFoldedComplete(target);
        }
        target.removeAttribute('style');
      }
    };
    wrapper.addEventListener('transitionend', onTransitionEnd);
    return () => {
      wrapper.removeEventListener('transitionend', onTransitionEnd);
    };
  }, []);
  const toggleList = () => {
    const content = listRef.current;
    const wrapper = foldRef.current;
    const items = [...content.querySelectorAll('.team-container')];
    let foldHeight = 0;
    if (window.matchMedia('min-width: 636px)').matches) {
      foldHeight = items[0].getBoundingClientRect().height + 24;
    } else {
      for (let index = 0; index < 3; index++) {
        foldHeight += items[index].getBoundingClientRect().height + 24;
      }
    }
    if (foldState) {
      wrapper.style.maxHeight = "".concat(foldHeight, "px");
      wrapper.classList.remove('folded');
      window.requestAnimationFrame(() => {
        setFoldState(false);
        wrapper.classList.add('expanding');
        wrapper.style.maxHeight = "".concat(content.getBoundingClientRect().height, "px");
      });
    } else {
      wrapper.style.maxHeight = "".concat(content.getBoundingClientRect().height, "px");
      wrapper.classList.remove('expanded');
      window.requestAnimationFrame(() => {
        setFoldState(true);
        wrapper.classList.add('folding');
        wrapper.style.maxHeight = "".concat(foldHeight, "px");
      });
    }
  };
  if (!hasRetailers) {
    return React.createElement(React.Fragment, null, React.createElement(DocumentTitle, {
      title: "Spela tillsammans"
    }), React.createElement(WelcomeRetail, {
      linkTo: findPath
    }), React.createElement(WidgetArea, {
      className: "marketplace-retail-widget-area",
      widgetArea: "retailWidgetArea"
    }));
  }
  return React.createElement(React.Fragment, null, React.createElement(DocumentTitle, {
    title: "Spela Tillsammans"
  }), React.createElement("div", {
    className: "bg-red-100 marketplace-full-width"
  }, React.createElement("div", {
    className: "marketplace-width-limiter"
  }, React.createElement("h2", {
    className: "welcome-team-list-header f-bold f-900 margin-top-0 margin-bottom-1"
  }, "Dina ombud"), React.createElement("div", {
    className: "welcome-team-list-wrapper folded",
    ref: foldRef
  }, React.createElement("div", {
    className: "welcome-team-list retailer",
    "data-testid": "qa-mkp-retail-teamlist",
    ref: listRef
  }, React.createElement(TeamListContainer, {
    history: history,
    isHeaderInverted: true,
    isRetail: true,
    maxGamesToDisplay: 3,
    shouldUseLastClicked: true
  }, team => React.createElement(GameList, {
    className: "game-list-welcome",
    fromTeamList: true,
    groupId: team.id,
    hasBottomBorder: true,
    isRetail: true,
    maxGamesToDisplay: 3,
    noFetch: true
  })))), React.createElement("div", {
    className: "welcome-team-list-button-container"
  }, React.createElement(Button, {
    block: true,
    className: "qa-welcome-retail-load-button",
    inverted: true,
    onClick: toggleList
  }, foldState ? 'Visa fler' : 'Visa färre')), React.createElement("div", {
    className: "padding-top-3"
  }, React.createElement("h2", {
    className: "welcome-team-list-header f-bold f-900 margin-top-0 margin-bottom-2"
  }, "S\xF6k andelsspel"), React.createElement("div", {
    className: "search-filter-wrapper",
    ref: filterRef
  }, React.createElement(Filter, {
    className: "marketplace-retail-search-filter",
    clearFilter: clearFilter,
    setFilterName: setFilterName,
    toggleProduct: toggleProduct,
    updateFractionCount: updateFractionCount,
    updateFractionPrice: updateFractionPrice,
    updateSystemPrice: updateSystemPrice,
    useFixedClass: false
  })), React.createElement("div", {
    className: "padding-top-2"
  }, React.createElement(Results, null))))), React.createElement(WidgetArea, {
    className: "marketplace-retail-widget-area",
    widgetArea: "retailWidgetArea"
  }));
};
setGlobal('svs.marketplace.components.welcome.RetailList', RetailList);

 })(window);